var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTickets = function SvgTickets(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39,
    height: 35,
    color: "#FFF",
    viewBox: "0 0 43 39"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "currentcolor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    transform: "translate(2 2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m5.374 15.576-1.424-3.95a1.554 1.554 0 0 1 .906-2.007L31.143.101a1.554 1.554 0 0 1 2.007.907l5.633 15.54a1.554 1.554 0 0 1-.906 2.006l-6.799 2.46M5.244 15.059 34.316 4.44m-5.374 6.345 2.913-1.036"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 31.078,
    height: 19.424,
    y: 15.576,
    rx: 2.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.18 24.64h9.064m7.77-3.884h3.885M5.179 29.82h1.296m5.18 0h1.294m5.18 0h1.295m5.18 0h1.295"
  }))));
};
export default SvgTickets;